import React from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import agenticBa from "../../Assets/Projects/agentic-ba.png";
import kounsel from "../../Assets/Projects/kounsel.png";
import senti from "../../Assets/Projects/senti.png";
import airflow from "../../Assets/Projects/airflow.png";
import dataMaestro from "../../Assets/Projects/DataMaestro.png";
import trafficManagement from "../../Assets/Projects/trafficmanagement.png";
import economicsYoyo from "../../Assets/Projects/economics_yoyo.png";
import hisabKitab from "../../Assets/Projects/Hisab_kitab_logo.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">      <Helmet>      <title>My Recent Works | Portfolio</title>
      <meta name="description" content="Check out my recent works and projects I've worked on." />
      <meta name="keywords" content="projects, recent works, portfolio, Kounsel, DataMaestro, Airflow, Traffic Management System, SUMO, Reinforcement Learning, Natural Language Processing, Economics YoYo, Flutter, Time Value of Money" />
      {/* Add any other necessary meta tags for SEO optimization */}
    </Helmet>
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={agenticBa}
              isBlog={false}
              title="Agentic BA Brain"
              description="AI-powered business analysis platform that autonomously conducts comprehensive market research, competitive analysis, and generates detailed business reports with iterative improvements and actionable insights."
              ghLink="https://github.com/nishamghimire5/Agentic-BA-Brain"
              demoLink="https://agenticba.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hisabKitab}
              isBlog={false}
              title="HisabKitab"
              description="Smart expense splitting app that simplifies group expense management with intelligent algorithms. Features real-time collaboration, optimized settlement recommendations, and partial participation support for seamless expense tracking."
              // ghLink=""
              demoLink="https://hisabbkitab.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dataMaestro}
              isBlog={false}
              title="DataMaestro"
              description="AI-powered CSV data processing application with SQL, natural language commands, and intelligent cleaning suggestions. Features include data profiling, standardization, and anomaly detection."
              ghLink="https://github.com/nishamghimire5/DataMaestro"
              demoLink="https://data-maestro.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={airflow}
              isBlog={false}
              title="Event-Driven File Processing"
              description="An automated file compression system using Airflow and MinIO for event-driven processing. Features include automatic file detection, compression, and email notifications."
              ghLink="https://github.com/nishamghimire5/airflow-file-compression"
              demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trafficManagement}
              isBlog={false}
              title="Traffic Management System"
              description="Traffic Management System using SUMO and Reinforcement Learning for optimizing traffic flow and reducing congestion at intersections with adaptive signal control."
              ghLink="https://github.com/nishamghimire5/Traffic-Management-System"
              demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kounsel}
              isBlog={false}
              title="Kounsel"
              description="Kounsel is a platform for students to share their feelings and discuss their mental problems without the fear of being judged."
              ghLink="https://github.com/nishamghimire5/Kounsel"
              demoLink="https://kounsel.vercel.app/"
            />
          </Col>          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={economicsYoyo}
              isBlog={false}
              title="Economics YoYo"
              description="An interactive mobile app for students to explore Time Value of Money (TVM) concepts through practical examples and calculations."
              ghLink="https://github.com/nishamghimire5/Economics-YoYo"
              demoLink=""
            />
          </Col>          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={senti}
              isBlog={false}
              title="Semti-Surfer"
              description="Senti-Surfer is a web extension that performs sentiment analysis on bilingual social media content to provide valuable insights."
              ghLink="https://github.com/nishamghimire5/senti-surfer-1"
              demoLink=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
